import React, { useContext, useEffect, useState } from 'react'
import PageTitle from '../Utilities/PageTitle'
import axios from 'axios';
import { BaseUrlContext } from '../Context/BaseUrl';
import { Link, useParams } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
export default function CourseDetails(props) {
    // get Course details
    let { course_id } = useParams();
    const { baseUrl, imgUrl } = useContext(BaseUrlContext);
    let [courseDetails, setCoursesDetails] = useState({});
    let [sessionDetails, setSessionDetails] = useState([]);
    async function getCourseDetails(course_id) {
        const bodyFormData = new FormData();
        bodyFormData.append('id', course_id);

        await axios.post(`${baseUrl}/get_course_details`, bodyFormData)
            .then(response => {
                // Handle the response
                if (response.data.Ecode === 200) {
                    console.log(response.data.Edata);
                    setCoursesDetails(response.data.Edata)
                    setSessionDetails(response.data.Edata.sessions)
                }

            })
            .catch(error => {

                // Handle any errors
                console.error(error);
            });

    }
    useEffect(() => {
        getCourseDetails(course_id);
    }, [course_id])

    // GET ALL COURSES
    let [courses, setCourses] = useState([]);
    async function getAllCourses() {

        await axios.post(`${baseUrl}/get_courses`)
            .then(response => {
                // Handle the response
                if (response.data.Ecode === 200) {
                    console.log(response.data.Edata);
                    setCourses(response.data.Edata);
                }

            })
            .catch(error => {

                // Handle any errors
                console.error(error);
            });

    }
    useEffect(() => {
        getAllCourses();
    }, [])

    // contact us in table short-contact

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const customStyles = {
        content: {
            top: '0',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            // transform: 'translate(-50%, -50%)',
        },
    };
    //  all values

    const [email, setEmail] = useState();
    const [submitMsg, setSubmitMsg] = useState('');
    const [message, setMessage] = useState('');

    async function submitForm(e) {
        e.preventDefault();
        const bodyFormData = new FormData();

        bodyFormData.append('email', email);
        bodyFormData.append('message', message);


        const response = await axios.post(`https://saudigermanacademy.com/Aadm25/api/mwforms/short_contact`, bodyFormData)
            .then(response => {
                // console.log(branchValue);
                // Handle the response
                if (response.data.Ecode === 200) {
                    // setCheckPhoneNum(response.data.Emsg);
                    console.log(response.data);
                    // handleShow();
                    if (response.data.Edata.request_id > 0) {
                        setSubmitMsg('Thank You!')
                        setMessage("Your form has been submitted successfully. We'll be in touch shortly.")
                    } else {
                        setSubmitMsg('Oppssss!! please Check Your Data ')

                    }

                    handleShow();

                }

            })
            .catch(error => {
                // Handle any errors
                console.error(error);
            });

    }
    useEffect(() => {
        if (show === false) {
            setEmail('');
            setMessage('');
        }

    }, [show])
    return <>
        <div className="main-content-area">
            <PageTitle title={courseDetails.name} homeLink='/' homePage='Home' prevLink='/courses' prevPage='Courses ' currentLink={`/courses/${courseDetails.name}/${courseDetails.id}`} />

            {/* <!-- Section: Course --> */}
            <section>
                <div className="container">
                    <div className="row">
                        <div className="order-2 col-md-8 blog-float-end">
                            <div className="single-service">
                                <img src={`${imgUrl}${courseDetails.image}`} alt={courseDetails.name} />
                                <h3 className="text-theme-colored line-bottom text-theme-colored">{courseDetails.name}</h3>
                                {/* <ul className="review_text list-inline">
                                    <li className="font-size-16"><span className="text-theme-color-2">Price :</span> {courseDetails.fees} LE</li>
                                    <li>
                                        <div className="star-rating" title="Rated 4.50 out of 5"><span style={{ width: '90%' }}>4.50</span></div>
                                    </li>
                                </ul> */}
                                <h5> <span className="text-theme-color-2">Overview</span></h5>
                                <div dangerouslySetInnerHTML={{ __html: courseDetails.description }}></div>
                                <h4 className="line-bottom mt-20 mb-20 text-theme-colored">All Courses Idea</h4>
                                {/* <ul className="nav nav  z-tabs boot-tabs" id="myTab" role="tablist">
                                    <li className="nav-item">
                                        <a className="nav-link active" id="course-set1-tab" data-bs-toggle="tab" href="#course-set1" role="tab" aria-controls="course-set1" aria-selected="true">Course Set 1</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" id="course-set2-tab" data-bs-toggle="tab" href="#course-set2" role="tab" aria-controls="course-set2" aria-selected="false">Course Set 2</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" id="course-set3-tab" data-bs-toggle="tab" href="#course-set3" role="tab" aria-controls="course-set3" aria-selected="false">Course Set 3</a>
                                    </li>
                                </ul> */}
                                <div className="tab-content border-0" id="myTabContent">
                                    <div className="tab-pane fade show active" id="course-set1" role="tabpanel" aria-labelledby="course-set1-tab">
                                        <table className="table table-bordered">
                                            <tr>
                                                <td className="text-center font-16 font-weight-600 bg-theme-colored2 text-white" colspan="4">Course Information</td>
                                            </tr>
                                            <tr> <th> Course Topic </th> <th>Date</th> <th>Time From</th> <th>Time To</th> </tr>
                                            <tbody>
                                                {sessionDetails.map((session, index) => <>
                                                    <tr key={index}> <th scope="row">Session {index + 1}</th> <td>{session.date}</td> <td>{session.from_time}</td> <td>{session.to_time}</td> </tr>

                                                </>)}

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* <div className="tab-pane fade" id="course-set2" role="tabpanel" aria-labelledby="course-set2-tab">
                                        <table className="table table-bordered">
                                            <tr>
                                                <td className="text-center font-16 font-weight-600 bg-theme-colored2 text-white" colspan="4">Prices For Course Set 2</td>
                                            </tr>
                                            <tr> <th>Coures Type</th> <th>className time</th> <th>Course Duration</th> <th>Price</th> </tr>
                                            <tbody>
                                                <tr> <th scope="row">Applied Psychology</th> <td>45 minutes</td> <td>3 years</td> <td>$810</td> </tr>
                                                <tr> <th scope="row">Business Administration (MBA)</th> <td>45 minutes</td> <td>2 years</td> <td>$940</td> </tr>
                                                <tr> <th scope="row">Computer Science (BSc)</th> <td>1 Hours</td> <td>4 years</td> <td>$1180</td> </tr>
                                                <tr> <th scope="row">Development Studies (MDS)</th> <td>1 Hours</td> <td>5 years</td> <td>$1400</td> </tr>
                                                <tr> <th scope="row">Engineering Technology (BSc)</th> <td>30 minutes</td> <td>3 years</td> <td>$600</td> </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="tab-pane fade" id="course-set3" role="tabpanel" aria-labelledby="course-set3-tab">
                                        <table className="table table-bordered">
                                            <tr>
                                                <td className="text-center font-16 font-weight-600 bg-theme-colored2 text-white" colspan="4">Prices For Course Set 3</td>
                                            </tr>
                                            <tr> <th>Coures Type</th> <th>className time</th> <th>Course Duration</th> <th>Price</th> </tr>
                                            <tbody>
                                                <tr> <th scope="row">Applied Psychology</th> <td>45 minutes</td> <td>3 years</td> <td>$810</td> </tr>
                                                <tr> <th scope="row">Business Administration (MBA)</th> <td>45 minutes</td> <td>2 years</td> <td>$940</td> </tr>
                                                <tr> <th scope="row">Computer Science (BSc)</th> <td>1 Hours</td> <td>4 years</td> <td>$1180</td> </tr>
                                                <tr> <th scope="row">Development Studies (MDS)</th> <td>1 Hours</td> <td>5 years</td> <td>$1400</td> </tr>
                                                <tr> <th scope="row">Engineering Technology (BSc)</th> <td>30 minutes</td> <td>3 years</td> <td>$600</td> </tr>
                                            </tbody>
                                        </table>
                                    </div> */}
                                    <div className="element pt-0 pt-lg-10 pb-0 text-center"><Link className="btn btn-theme-colored2 btn-sm ajaxload-popup btn-booking w-25" to={`/courses/${courseDetails.name}/${courseDetails.id}/register`} >Book Now</Link></div>
                                    {/* <div className="element pt-0 pt-lg-10 pb-0 text-center"><Link className="btn btn-theme-colored2 btn-sm ajaxload-popup btn-booking w-50" >For Booking Call 16259</Link></div> */}
                                </div>
                            </div>
                        </div>
                        <div className="order-1 col-sm-12 col-md-4">
                            <div className="sidebar sidebar-left mt-sm-30 ml-40">
                                <div className="tm-sidebar-nav-menu-style2">
                                    <h4 className="widget-title line-bottom">Courses <span className="text-theme-color-2">List</span></h4>
                                    <div className="widget widget_nav_menu">
                                        <ul>
                                            {courses.map((course, index) => <>
                                                <li key={index}><Link to={`/courses/${course.name}/${course.id}`}>{course.name}</Link></li>
                                            </>)}

                                        </ul>
                                    </div>
                                </div>
                                <div className="widget">
                                    <h4 className="widget-title line-bottom">Course <span className="text-theme-color-2">Details</span></h4>
                                    <div className="opening-hours">
                                        <ul className="list-border">
                                            <li className="clearfix"> <span> Duration :</span>
                                                <div className="value float-end">{courseDetails.Duration} </div>
                                            </li>
                                            <li className="clearfix"> <span> Start Date : </span>
                                                <div className="value float-end">{courseDetails.start_date} </div>
                                            </li>
                                            <li className="clearfix"> <span> End Date : </span>
                                                <div className="value float-end"> {courseDetails.end_date} </div>
                                            </li>
                                            <li className="clearfix"> <span> Language : </span>
                                                <div className="value float-end"> {courseDetails.Language} </div>
                                            </li>
                                            <li className="clearfix"> <span> Study Format :  </span>
                                                <div className="value float-end"> {courseDetails.study_format} </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="widget border-1px p-30">
                                    <h5 className="widget-title text-theme-colored1">Contact Us</h5>
                                    <form name="quick_contact_form" className="quick-contact-form" onSubmit={submitForm} method="post">
                                        <div className="mb-3">
                                            <input name="form_email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Enter Email" required />
                                        </div>
                                        <div className="mb-3">
                                            <textarea name="form_message" className="form-control" value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Enter Message" rows="3" required></textarea>
                                        </div>
                                        <div className="mb-3 tm-sc-button">
                                            <input name="form_botcheck" className="form-control" type="hidden" value="" />
                                            <button type="submit" className="btn btn-theme-colored1 btn-sm" data-loading-text="Please wait..."> Send Message </button>
                                        </div>
                                    </form>

                                    <Modal   {...props}
                                        size="lg"
                                        style={customStyles}
                                        aria-labelledby="contained-modal-title-vcenter"
                                        centered show={show} onHide={handleClose} className="top-0 ">

                                        <Modal.Header closeButton>
                                            <img className="" src='/images/cropped-9952-img-32x32.jpg' alt="" />

                                            <Modal.Title className='text-theme-colored2 fw-bold'>Contact Us</Modal.Title>
                                        </Modal.Header>

                                        <Modal.Body>
                                            <div className="team-member text-center">
                                                <div className="team-description pt-0">
                                                    <h3><Link>{submitMsg}</Link></h3>
                                                    <p className='lead'>{message}</p>
                                                </div>



                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button className='btn btn-theme-colored2 btn-sm appoint-btn mt-3 mt-sm-0 ' variant="secondary" onClick={handleClose}>
                                                Close
                                            </Button>

                                        </Modal.Footer>

                                    </Modal>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </>
}
